import { FC } from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { Face } from '../ApiTypes';
import { getFaceCroppedSrc } from '../Storage';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
`;

const AllButton = styled.button<{ $active: boolean }>`
  flex-shrink: 0;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid ${props => props.$active ? 'rgb(254, 167, 0)' : '#3a3a3a'};
  background-color: ${props => props.$active ? 'rgba(254, 167, 0, 0.15)' : 'transparent'};
  color: ${props => props.$active ? 'rgb(254, 167, 0)' : '#8a8a8a'};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
`;

const FaceButton = styled.button<{ $active: boolean }>`
  flex-shrink: 0;
  padding: 0px;
  border-radius: 50%;
  border: 2px solid ${props => props.$active ? 'rgb(254, 167, 0)' : 'transparent'};
  background: none;
  cursor: pointer;
  line-height: 0;
  opacity: ${props => props.$active ? 1 : 0.65};

  &:hover {
    opacity: 1;
  }
`;

const FaceImg = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

/**
 * 顔で一覧を絞り込む横並びのフィルタ。
 * `faceId` が null のときは全件。
 */
const FaceFilter: FC<{
  faces: Face[],
  faceId: string|null,
  onChange(faceId: string|null): void,
}> = (props) => {
  if (props.faces.length < 2) {
    // 顔が 1 つしかなければ絞り込む意味がない。
    return <></>;
  }

  return <Container>
    <AllButton $active={props.faceId === null} onClick={() => props.onChange(null)}>
      <Trans>All faces</Trans>
    </AllButton>
    {props.faces.map(face => <FaceButton
      key={face.faceId}
      $active={props.faceId === face.faceId}
      onClick={() => props.onChange(props.faceId === face.faceId ? null : face.faceId)}>
      <FaceImg src={getFaceCroppedSrc(face)} />
    </FaceButton>)}
  </Container>;
};

export default FaceFilter;
